// extracted by mini-css-extract-plugin
module.exports = {"image":"Disclaimer_image__Scgco","contactInfo":"Disclaimer_contactInfo__1Yj0B"};